import { useState, useEffect, useRef } from "react";

export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<"up" | "down">("up");
  const lastScrollYRef = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      
      // Don't trigger direction change if we're at the very top
      if (scrollY < 20) {
        if (scrollDirection !== "up") {
          setScrollDirection("up");
        }
        lastScrollYRef.current = scrollY;
        ticking.current = false;
        return;
      }
      
      // Check direction with threshold
      const scrollDiff = scrollY - lastScrollYRef.current;
      
      if (Math.abs(scrollDiff) > 5) {
        const newDirection = scrollY > lastScrollYRef.current ? "down" : "up";
        
        if (newDirection !== scrollDirection) {
          setScrollDirection(newDirection);
        }
        lastScrollYRef.current = scrollY;
      }
      
      ticking.current = false;
    };

    const onScroll = () => {
      if (!ticking.current) {
        ticking.current = true;
        requestAnimationFrame(updateScrollDirection);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [scrollDirection]);

  return { scrollDirection };
}